import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import stars from '@/images/agents/stars.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import Button from '@mui/material/Button';

const Container = styled.div`
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    gap: 4px;
    width: 680px;
    padding: 4px 10px;
`;

const StyledButton = styled(Button)<{ main?: boolean }>`
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    height: 34px;
    text-transform: none;
    border-radius: 8px;
    padding: 10px 16px;
    outline: ${({ main = false, theme }) => (main ? 'none' : '1px solid ' + theme.colors.black[300])};
    background-color: ${({ main = false }) => (main ? theme.colors.primary.main : 'transparent')};
    color: ${({ main = false }) => (main ? theme.colors.secondary.main : 'white')};
    box-shadow: none;

    &:hover {
        box-shadow: none;
        outline: none;
        background: ${({ main }) => (main ? '#ED7921' : 'white')};
        color: ${({ main }) => (main ? 'white' : 'black')};
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    gap: 8px;
`;

const MainContainer = styled.div`
    display: flex;
    gap: 4px;
`;

interface Props {
    onClose: () => void;
    onSubmit: () => void;
}

export function V2UpgradeSuccessToast({ onClose, onSubmit }: Props) {
    return (
        <Container>
            <MainContainer>
                <MaskedIcon size="24px" src={stars} color={theme.colors.primary.main} />
                We've successfully generated your Agent!
            </MainContainer>
            <ButtonContainer>
                <StyledButton onClick={onClose} variant="contained">
                    Maybe later
                </StyledButton>
                <StyledButton onClick={onSubmit} variant="contained" main>
                    Preview
                </StyledButton>
            </ButtonContainer>
        </Container>
    );
}
